import Overview from "./Overview";
import Benefits from "./Benefits";
import ExtraBenefits from "./ExtraBenefits";
import DrugCoverage from "../DrugCoverage";
import DocumentsAndContact from "./DocumentsAndContact";
import Navigation from "./Navigation";
import StarRatings from "./StarRatings";
import OptionalSupplementalBenefits from "./OptionalSupplementalBenefits";

export default {
  Overview,
  Benefits,
  ExtraBenefits,
  DrugCoverage,
  DocumentsAndContact,
  Navigation,
  StarRatings,
  OptionalSupplementalBenefits,
};
